// apiRequest already converts server responses to readable Error messages.
// React renders this as text, never HTML.
export function governanceErrorMessage(error: unknown): string {
  return error instanceof Error && error.message.trim()
    ? error.message
    : "Unable to complete this action. Please try again.";
}
